import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FormatMilesTypeLabelPipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatMilesTypeLabel',
})
export class FormatMilesTypeLabelPipe implements PipeTransform {
  /**
   * Takes a `milesType` value from a job and formats the appropriate job label
   *  E.g. `milesperweek` -> "Miles Per Week:"
   */
  transform(value: string, ...args) {
    if (value === 'milesperweek') {
      return 'Miles Per Week:';
    } else if (value === 'milespermonth') {
      return 'Miles Per Month:';
    } else if (value === 'calltodiscuss') {
      return 'Miles Per Week/Month:';
    } else {
      return 'Miles:';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-miles-type-label/format-miles-type-label.ts